import React from 'react'
import Detail from '../../components/Detail/Detail'
import './PageDetail.css'
export default function PageDetail() {
    return (
        <div className='pageDetail'>
            <Detail />

        </div>
    )
}
